<template>
  <div>
    <page-title
      heading="Rekam Medis"
      :breadcrumb="[
        {
          label: 'Rekam Medis',
          link: '/klinik-rekam-medis'
        },
        {
          label: 'List Rekam Medis',
          active: true
        }
      ]"
    />

    <div class="container-fluid">
      <div class="card card-box mb-3 ninja-shadow">
        <div class="card-body">
          <div class="col-md-12 no-padding">
            <DataTableWrapper
              :perPage="perPage"
              :fromPage="fromPage"
              :toPage="toPage"
              :totalEntries="totalEntries"
              :currentPage="currentPage"
              :callbackFunc="fetchListRekamMedis"
              @valueChanged="handleValueChanged"
            >
              <b-table
                :items="rekam_medisList"
                :fields="fieldList"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                thead-tr-class="izd-datatable"
                :no-local-sorting="true"
              >
                <template v-slot:head()="data">
                  {{ data.label }}
                  <b-input
                    size="sm"
                    class="mt-2 w-95"
                    v-if="data.field.searchable"
                    @input="searchValueChanged($event, data.field.key)"
                  />
                </template>
                <template v-slot:cell(nomor_rekam_medis)="data">
                  <div class="align-center">
                    {{ data.value }}
                    <span
                      v-if="data.item.nomor_rekam_medis_manual !== null &&
                      data.item.nomor_rekam_medis_manual !== ''"
                      :id="'rm-manual-' + data.item.id"
                      v-tooltip="{
                        content: `<strong>NO.RM MANUAL</strong><br/>${data.item.nomor_rekam_medis_manual}`,
                        classess: 'rm-manual'
                      }"
                    >
                      <font-awesome-icon
                        class="align-middle"
                        style="color: #33bdff; padding: 5px; font-size:2.3em; margin-top: -5px"
                        icon="clipboard-list"
                      />
                    </span>
                  </div>
                </template>
                <template v-slot:cell(jenis_kelamin)="data">
                  {{ jenisKelamin(data.value) }}
                </template>
                <template v-slot:cell(nomor_hp)="data">
                  {{ data.item.nomor_hp_prefix ? `+${data.item.nomor_hp_prefix}` : '' }}{{ data.value }}
                </template>
                <template v-slot:cell(actions)="data">
                   <span class="d-flex align-items-center justify-content-between">
                    <b-button
                      @click="
                        detailRiwayatRekamMedis({
                          pasien_id: data.item.pasien_id
                        })
                      "
                      variant="primary"
                      size="sm"
                      v-tooltip="'Riwayat Rekam Medis'"
                      ><font-awesome-icon icon="search"
                    /></b-button>
                  </span>
                </template>
                <template v-slot:cell(viewed)="data">
                  <label style="font-size:12px;">
                    {{ data.item.viewed.at }} <br>
                    by <b>{{ data.item.viewed.by }}</b>
                  </label>
                </template>
              </b-table>
            </DataTableWrapper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import debounce from "lodash/debounce";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowRight,
  faArrowUp,
  faTrashAlt,
  faSearch,
  faPencilAlt,
  faCopy,
  faClipboardList,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
moment.locale('id');
import "vue-datetime/dist/vue-datetime.css";
library.add(faArrowRight, faArrowUp, faTrashAlt, faSearch, faPencilAlt, faCopy, faClipboardList);

export default {
  components: {
    DataTableWrapper: () => import("../../components/DataTableWrapper"),
  },
  data() {
    return {
      sortBy: "",
      sortDesc: false,
      currentPage: 1,
      rows: 0,
      fromPage: 0,
      toPage: 0,
      perPage: 10,
      rekam_medisList: [],
      namaPasien: "",
      isOperator: "",
      noRekamMedis: "",
      tanggalLahir: "",
      searchValue: [],
      totalEntries: 0,
    };
  },
  mounted() {
    this.setCloseMR();
    // delete edit rekam medis
    this.deleteLocalStorage()
    this.cekPaketNolock();
    if (!this.isDoctor) {
      this.isOperator = true;
    } else {
      this.isOperator = false;
    }
  },
  watch: {
    currentPage() {
      this.fetchListRekamMedis();
    },
    perPage() {
      this.fetchListRekamMedis();
    },
    sortBy() {
      this.fetchListRekamMedis();
    },
    sortDesc() {
      this.fetchListRekamMedis();
    },
    searchValue: {
      handler: "fetchListRekamMedis",
      deep: true
    }
  },
  computed: {
    ...mapGetters({
      isDoctor: "doctorRole",
      getKlinikId: "getKlinikId",
    }),
    fieldList() {
      const {
        generateFieldList: g,
        setSearchableAndSortableFieldList: s
      } = this;
      const r = val => Boolean(/(no|actions|viewed)\b/gi.test(val) ? !1 : 1);
      return (
        [
          { key: "no" },
          { key: "nomor_rekam_medis" },
          { key: "nama", label: "nama pasien" },
          { key: "jenis_kelamin" },
          { key: "nomor_hp" },
          { key: "actions" },
          { key: "viewed", label: "last viewed by" }
        ]
        |> (v => s({ field: v, customFunc: r }))
        |> (z => g({ field: z }))
      );
    }
  },
  methods: {
    setCloseMR(){
      localStorage.setItem('ALLOW_BACK_MR_TAB', 1);
    },
    handleValueChanged({ perPage, currentPage }) {
      perPage && (perPage |> (_ => (this.perPage = _)));
      currentPage && (currentPage |> (_ => (this.currentPage = _)));
    },
    searchValueChanged: debounce(function(val, key) {
      const { searchValue } = this;

      const z = searchValue.filter(item => item.key !== key);
      this.searchValue = [
        ...z,
        {
          key,
          value: val
        }
      ];
    }, 500),
    rekamMedis({ klinik_id, pasien_id }) {
      this.$router.push(`/klinik-rekam-medis/${klinik_id}/${pasien_id}`);
    },
    async detailRiwayatRekamMedis({ pasien_id } = {}) {
      if (pasien_id) {

          localStorage.setItem('rekam_medis', window.location.pathname)
          localStorage.setItem('with_parent', 0)
          this.$router.push({
            name: "klinik-rekam-medis-riwayat",
            params: {
              pasien_id: pasien_id
            }
          });
        
      }
    },
    determineParameter() {
      const { searchValue, sortBy, sortDesc } = this;
      let v = "";
      searchValue.map(item => {
        const x = (item.key === "nama" && "nama_pasien") || item.key;
        v += `&${x}=${item.value}`;
      });
      if (sortBy) {
        v += `&column=${sortBy}&order=${sortDesc ? "desc" : "asc"}`;
      }
      return v;
    },
    async fetchListRekamMedis() {
      try {
        const res = await this.$axios.get(
          `rekam_medis?klinik_id=${this.getKlinikId}&limit=${this.perPage}&page=${
            this.currentPage
          }${this.determineParameter()}`
        );
        const { success, data } = res.data;
        if (success) {
          const { total } = data;
          const {
            data: listRekamMedis,
            total: totalEntries,
            to: toPage,
            from: fromPage
          } = data;
          this.totalEntries = totalEntries;
          this.toPage = toPage;
          this.fromPage = fromPage;
          this.rows = totalEntries;

          this.rekam_medisList = [
            ...listRekamMedis.map((item, index) => {
              return {
                ...item,
                no: (this.currentPage - 1) * this.perPage + index + 1,
                nomor_rekam_medis_manual: typeof item.nomor_rekam_medis_manual === 'undefined' ? null : item.nomor_rekam_medis_manual,
                viewed: {
                  at: item.viewed.at == null ? null : this.formatedDate(item.viewed.at),
                  by: item.viewed.by || 'anonim'
                }
              };
            })
          ];
          return this;
        }
      } catch (err) {
      }
    },
    formatedDate(d) {
      return moment(d).format("D MMM YYYY @ HH:mm");
    },
    deleteLocalStorage() {
      localStorage.removeItem('poli_id')
      localStorage.removeItem('rekam_medis_id')
      localStorage.removeItem('edit_rekam_medis')
      localStorage.removeItem('rm_reload')
      localStorage.removeItem('edit_rujukan')
    },
  }
};
</script>
<style scoped lang="css">
  .bg-kuning {
    background: #f7fc6b;
  }

  .bg-kuning,
  .bg-danger,
  .bg-first {
    color: black !important;
  }

  .no-padding {
    padding: 0 !important;
  }

  .page-item.active a {
    background: #3b86ff;
    border: none !important;
  }

  .ninja-shadow {
    box-shadow: 0px 8px 15px 0px lightgrey;
  }
</style>
  
<style lang="css">
  .tooltip {
    display: block !important;
    z-index: 10000;
  }

  .tooltip .tooltip-inner {
    background: rgb(18, 106, 207);
    color: white;
    border-radius: 5px;
    padding: 5px 10px 4px;
    box-shadow: 0px 0px 0px rgba(black, .1) !important;
  }

  .tooltip .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: rgb(18, 106, 207);
    z-index: 1;
  }
</style>
